import React from "react";
import { Box } from "@mui/material";
import { Header } from "../formsAndFiles/probate/Header";
import { ATTICUS_PAGE_PREFIX, PAGE_CONTENT_WIDTH } from "../../constants";
import Page from "../../components/Page";

interface Props {
  title?: string;
  pageSuffix?: string;
  step?: number;
  totalSteps?: number;
  completedAll?: boolean;
  children: JSX.Element;
  hideImage?: boolean;
  showBeta?: boolean;
  style?: { [key: string]: any },
}

const contentAndHeaderMaxWidth = {
  md: PAGE_CONTENT_WIDTH,
  sm: "none",
  xs: "none",
} as const;

export const ScreenContentWrapper = ({
  title,
  children,
  step,
  totalSteps = 0,
  completedAll,
  pageSuffix,
  hideImage,
  showBeta,
  style,
}: Props): JSX.Element => {
  return (
    <Page title={`${ATTICUS_PAGE_PREFIX} - ${pageSuffix}`}>
      <div style={style || undefined}>
        {title && (
          <Header
            title={title}
            step={step}
            totalSteps={totalSteps}
            completedAll={completedAll}
            hideImage={hideImage}
            showBeta={showBeta}
          />
        )}
        <Box
          sx={{
            mb: 2,
            maxWidth: contentAndHeaderMaxWidth,
          }}
        >
          {children}
        </Box>
      </div>
    </Page>
  );
};
